export const LINK_STATUS = {
  NONE: 'none',
  LINK: 'link',
  UNLINK: 'unlink'
};
